/**
 * Chiavi React Query centralizzate (come su gestionale-gls). Ogni chiave
 * nuova va aggiunta anche in core/mutationInvalidator.js e in
 * hooks/useRealtimeSync.js, altrimenti con staleTime: Infinity i dati non
 * si aggiornano più.
 */
export const queryKeys = {
  catalogo: ["catalogo"],
  panoramica: ["panoramica"],
  contatori: ["contatori"],
  piano: ["piano"],
  clienti: (params = {}) => ["clienti", params],
  clientiElenco: ["clientiElenco"],
  cliente: (id) => ["cliente", Number(id)],
  // Sotto ["cliente", id]: clienti:changed lo rilegge insieme alla scheda.
  clienteDocumenti: (id) => ["cliente", Number(id), "documenti"],
  dipendenti: (params = {}) => ["dipendenti", params],
  dipendente: (id) => ["dipendente", Number(id)],
  dipendentePresenze: (id, anno) => ["dipendentePresenze", Number(id), Number(anno)],
  presenzeMese: (clienteId, anno, mese) => ["presenzeMese", Number(clienteId), Number(anno), Number(mese)],
  scadenze: (params = {}) => ["scadenze", params],
  scadenza: (id) => ["scadenza", Number(id)],
  paghe: (anno, mese) => ["paghe", Number(anno), Number(mese)],
  pagheCliente: (clienteId, anno, mese) => ["pagheCliente", Number(clienteId), Number(anno), Number(mese)],
  cedolino: (id) => ["cedolino", Number(id)],
  pagheCatalogo: (anno) => ["pagheCatalogo", Number(anno)],
  pagheTabelle: ["pagheTabelle"],
  impostazioni: ["impostazioni"],
  impostazioniCliente: (id) => ["impostazioniCliente", Number(id)],
  impostazioniDipendente: (id) => ["impostazioniDipendente", Number(id)],
  timbrature: (clienteId, anno, mese) => ["timbrature", Number(clienteId), Number(anno), Number(mese)],
  importazioni: ["importazioni"],
  importProfili: ["importProfili"],
  ocrStato: ["ocrStato"],
  ocrLotti: ["ocrLotti"],
  ocrLotto: (id) => ["ocrLotto", Number(id)],
  notifiche: ["notifiche"],
  people: ["people"],
  users: ["users"],
  ruoli: ["ruoli"],
  inviti: ["inviti"],
  richieste: ["richieste"],
  azienda: ["azienda"],
  subscription: ["subscription"],
  contratto: ["contratto"],
  contrattoTesti: ["contrattoTesti"],
  emailPrefs: ["emailPrefs"],
  me: ["me"],
};
